/**
 * Used in the form builder field list
 */
const fieldGroup = 'fieldGroup';

export default {
  fieldGroup
};
